<template>
  <div class="user-detail-seckill-orders">
    <el-row :gutter="20" style="width:100%">
      <el-col :span="24" style="width:100%">
        <div class="text-right"></div>
      </el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="userDetailSeckillOrdersInfo.orders" border style="width: 100%">
        <el-table-column prop="orderId" :label="$t('userDetailSeckillOrders.orderId')" align="center">
        </el-table-column>
        <el-table-column :label="$t('userDetailSeckillOrders.productImage')" align="center">
          <template slot-scope="scope">
            <el-image style="width: 50px; height: 50px; border-radius: 10px;" :src="scope.row.coverPhoto"
              :preview-src-list="[scope.row.coverPhoto]" fit="cover">
              <div slot="error" class="image-slot">
                <img src="/img/noPhoto.jpg" style="width:50px;height:50px;border-radius:10px;">
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="prodName" :label="$t('userDetailSeckillOrders.productName')" align="center">
        </el-table-column>
        <el-table-column prop="buyerName" :label="$t('userDetailSeckillOrders.buyer')" align="center">
        </el-table-column>
        <el-table-column prop="goodsNum" :label="$t('userDetailSeckillOrders.buyQuantity')" align="center">
        </el-table-column>
        <el-table-column prop="killPrice" :label="$t('userDetailSeckillOrders.seckillAmount')" align="center">
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('userDetailSeckillOrders.buyTime')" align="center">
        </el-table-column>
        <el-table-column prop="state" :label="$t('userDetailSeckillOrders.status')" align="center">
          <template slot-scope="scope">
            {{ scope.row.state === 'C' ? $t('userDetailSeckillOrders.completed') :
              $t('userDetailSeckillOrders.pendingPayment') }}
          </template>
        </el-table-column>
        <el-table-column prop="endTime" :label="$t('userDetailSeckillOrders.deadline')" align="center">
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row :gutter="20" class="margin-top">
        <el-col :span="16"></el-col>
        <el-col :span="8">
          <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getSeckillOrderList } from '@/api/user/userDetailSeckillOrdersApi'

export default {
  name: 'UserDetailSeckillOrders',
  data() {
    return {
      userDetailSeckillOrdersInfo: {
        orders: [],
        buyerId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
    open(data) {
      this.userDetailSeckillOrdersInfo.buyerId = data.userId
      this.loadSeckillOrderData()
    },
    loadSeckillOrderData() {
      const params = {
        buyerId: this.userDetailSeckillOrdersInfo.buyerId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }
      getSeckillOrderList(params).then(res => {
        this.userDetailSeckillOrdersInfo.orders = res.data
        this.pagination.total = res.records
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadSeckillOrderData()
    }
  }
}
</script>

<style scoped>
.user-detail-seckill-orders {
  padding: 20px;
}

.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>